import { SERVER_DEBUG_LOG_ENABLED } from './logging-policy';
import { logServerError, logServerSuccess, nextServerLogId, toLogRequestObject } from './server-log';

/** Logs JSON responses without consuming or changing the response returned to the caller. */
export async function fetchWithBackendLog(input: string, init?: RequestInit): Promise<Response> {
  if (!SERVER_DEBUG_LOG_ENABLED) return fetch(input, init);
  const id = nextServerLogId();
  const startedAt = Date.now();
  const method = `${init?.method ?? 'GET'} ${input.split(/[?#]/)[0]}`;
  let request: unknown;
  try {
    // Parse JSON before redaction; never print serialized credentials verbatim.
    if (typeof init?.body === 'string') {
      const contentType = new Headers(init.headers).get('Content-Type') ?? '';
      const body = contentType.includes('application/x-www-form-urlencoded')
        ? Object.fromEntries(new URLSearchParams(init.body)) : JSON.parse(init.body);
      request = toLogRequestObject(body, method);
    } else if (init?.body instanceof URLSearchParams) request = toLogRequestObject(Object.fromEntries(init.body), method);
  } catch { /* Omit non-JSON bodies. */ }
  try {
    const response = await fetch(input, init);
    // Read a clone so the application's response.json() remains untouched.
    try {
      const body: unknown = await response.clone().json();
      const options = { id, request, durationMs: Date.now() - startedAt, transport: { status: response.status } };
      if (response.ok) logServerSuccess('BACKEND HTTP', method, body, options);
      else logServerError('BACKEND HTTP', method, body, options);
    } catch {
      const write = response.ok ? logServerSuccess : logServerError;
      write('BACKEND HTTP', method, { body: 'Resposta sem JSON' }, {
        id, request, durationMs: Date.now() - startedAt, transport: { status: response.status },
      });
    }
    return response;
  } catch (error: unknown) {
    logServerError('BACKEND HTTP', method, error, { id, request, durationMs: Date.now() - startedAt });
    throw error;
  }
}

